<template>
    <section>
    <el-form class="login-form" status-icon :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left" label-width="0px">
        <el-form-item prop="username">
            <el-input size="small" @keyup.enter.native="handleLogin" v-model="loginForm.username" auto-complete="off" placeholder="请输入用户名">
                <i slot="prefix" class="icon-user"></i>
            </el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input size="small" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off" placeholder="请输入密码">
                <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
                <i slot="prefix" class="icon-password"></i>
            </el-input>
        </el-form-item>
        <el-checkbox v-model="checked" class="remember">记住账号</el-checkbox>
        <el-form-item >
            <el-button size="small" type="primary" @click.native.prevent="handleLogin" class="login-submit" :loading="loginLoading">登录</el-button>
        </el-form-item>
    </el-form>
    </section>
</template>

<script>
    import axios from 'axios';

    const instance = axios.create({
      timeout: 10000
    });

    instance.defaults.withCredentials = true;
    const baseDir = "http://zwerp.zwcloud.wang:8088/ZowellERP";//正式
    //  const baseDir = 'http://' + window.location.hostname + ":8080/ZowellERP";//本地
    // const baseDir ="http://zwerp-test.p6sai.com:8860/ZowellERP";
    const requestLogin = params => { return instance.post(baseDir + '/user/login', params); };

    export default {
        mounted() {
            this.checkRemember();
        },
        data() {
            return {
                loginLoading: false,
                loginForm: {
                    username: '',
                    password: ''
                },
                loginRules: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ]
                },
                passwordType: 'password',
                checked: false
            };
        },
        methods: {
            showPassword() {
                this.passwordType === ''
                    ? (this.passwordType = 'password')
                    : (this.passwordType = '')
                },
            checkRemember() {
                if (window.sessionStorage.getItem("remember") === "true") {
                    this.checked = true;
                    this.loginForm.username = window.sessionStorage.getItem("username");
                    this.loginForm.password = window.sessionStorage.getItem("password")
                }
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        let self = this;
                        this.loginLoading = true;
                        let loginParams = {username: this.loginForm.username, password: this.loginForm.password};
                        requestLogin(loginParams).then(res => {
                            self.loginLoading = false;
                            if (res.data.code !== 0) {
                                self.$message.error(res.data.msg);
                            } else {
                                sessionStorage.setItem('username', this.loginForm.username);
                                sessionStorage.setItem('password', this.loginForm.password);
                                sessionStorage.setItem('remember', String(this.checked));
                                self.$router.push({name: '/home'});
                            }
                        })
                    }
                })
            },
        }
    }

</script>

<style lang="scss" scoped>
    .remember{
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/login/userlogin.vue